import React, { useEffect, useState } from 'react';
import { ArrowDown } from 'lucide-react';

interface PullToRefreshProps {
  onRefresh: () => Promise<void>;
  children: React.ReactNode;
}

export function PullToRefresh({ onRefresh, children }: PullToRefreshProps) {
  const [startY, setStartY] = useState(0);
  const [pulling, setPulling] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let touchStartY = 0;
    let touchMoveY = 0;

    const handleTouchStart = (e: TouchEvent) => {
      if (window.scrollY === 0) {
        touchStartY = e.touches[0].clientY;
        setStartY(touchStartY);
        setPulling(true);
      }
    };

    const handleTouchMove = (e: TouchEvent) => {
      if (pulling) {
        touchMoveY = e.touches[0].clientY;
        const pullDistance = touchMoveY - touchStartY;
        
        if (pullDistance > 0 && pullDistance < 100) {
          document.body.style.marginTop = `${pullDistance}px`;
        }
      }
    };

    const handleTouchEnd = async () => {
      if (pulling) {
        setPulling(false);
        const pullDistance = touchMoveY - startY;
        
        if (pullDistance > 60) {
          setLoading(true);
          document.body.style.marginTop = '0px';
          await onRefresh();
          setLoading(false);
        } else {
          document.body.style.marginTop = '0px';
        }
      }
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [onRefresh, pulling, startY]);

  return (
    <div className="relative">
      {loading && (
        <div className="fixed top-0 left-0 right-0 flex items-center justify-center bg-blue-500 text-white py-2 z-50">
          <ArrowDown className="w-5 h-5 animate-bounce mr-2" />
          Actualisation...
        </div>
      )}
      {children}
    </div>
  );
}